@if (isChatEnabled()) {
    <div class="TotemCustomerCareCall py-3">
        @if (isLoading || isSaving) {
            <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
        }
        @if (!isLoading) {
            <div class="container TotemCustomerCareCall-Main">
                @if (bookingData != null) {
                    <div class="container">
                        <div class="row border-bottom pb-3 mb-3">
                            <div class="col-12">
                                <h3 class="mb-0">{{ 'totem-customer-care-call.welcome' | locTranslate }}:</h3>
                            </div>
                        </div>
                    </div>
                    <app-pg-customer-care-booking [bookingData]="bookingData"></app-pg-customer-care-booking>
                    <div class="container">
                        @if (!showChat) {
                            <div class="row border-top pt-3 TotemCustomerCareCall-Main-Action">
                                @if (bookingData.status == 'pending') {
                                    <div class="col-12">
                                        <div>{{ 'totem-customer-care-call.status-pending' | locTranslate }}</div>
                                        <button class="btn btn-primary mt-3" [disabled]="!canConfirm()" (click)="doConfirm()">{{ 'totem-customer-care-call.button-confirm' | locTranslate }}</button>
                                    </div>
                                }
                                @if (bookingData.status == 'canceled') {
                                    <div class="col-12">
                                        <div class="text-danger">{{ 'totem-customer-care-call.status-canceled' | locTranslate }}</div>
                                    </div>
                                }
                                @if (bookingData.status == 'confirmed') {
                                    <div class="col-12">
                                        @if (!showChat) {
                                            @if (isPast) {
                                                <h5 class="text-danger">{{ 'totem-customer-care-call.status-confirmed-past' | locTranslate }}</h5>
                                            }
                                            @if (!isPast) {
                                                <div>
                                                    <h5>{{ 'totem-customer-care-call.status-confirmed' | locTranslate }}</h5>
                                                    <div>{{ 'totem-customer-care-call.status-confirmed-future' | locTranslate }}</div>
                                                </div>
                                            }
                                        }
                                    </div>
                                }
                            </div>
                        }
                        @if (showChat) {
                            <div class="row border-top pt-3 TotemCustomerCareCall-Main-Chat">
                                <div class="col-12 p-0">
                                    <app-pg-customer-care [chatBooking]="bookingData.pid"></app-pg-customer-care>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}